import { msalInstance } from '../index'

/**
 * Validates if the current MSAL session is still valid
 * Clears stale data if session is invalid
 */
export const validateMsalSession = async () => {
  try {
    const activeAccount = msalInstance.getActiveAccount()

    if (!activeAccount) {
      // No active account, clear any stale tokens
      clearStaleSessionData()
      return false
    }

    // Try to silently acquire a token to validate the session
    try {
      await msalInstance.acquireTokenSilent({
        scopes: ['User.Read'],
        account: activeAccount,
      })
      return true // Session is valid
    } catch (error) {
      console.warn('MSAL session validation failed:', error)
      // Session is stale, clear it
      await clearStaleSessionData()
      return false
    }
  } catch (error) {
    console.error('Session validation error:', error)
    await clearStaleSessionData()
    return false
  }
}

/**
 * Clears all stale session data from storage and MSAL cache
 */
export const clearStaleSessionData = async () => {
  try {
    // Clear localStorage tokens
    const tokenKeys = ['accessToken', 'userSessionName', 'userSessionEmail']
    tokenKeys.forEach((key) => {
      localStorage.removeItem(key)
      sessionStorage.removeItem(key)
    })

    // Clear all MSAL accounts
    const accounts = msalInstance.getAllAccounts()
    for (const account of accounts) {
      try {
        await msalInstance.removeAccount(account)
      } catch (e) {
        // Ignore individual account removal failures
        console.warn('Failed to remove account:', e)
      }
    }

    console.log('Stale session data cleared')
  } catch (error) {
    console.error('Error clearing stale session data:', error)
  }
}

/**
 * Checks if we're returning from a browser closure scenario
 * (when user closed browser and reopened later)
 */
export const isBrowserRestoredSession = () => {
  // Check if we have tokens but no active session storage indicators
  const hasLocalTokens =
    localStorage.getItem('accessToken') || localStorage.getItem('userSessionName')
  const hasSessionIndicators =
    sessionStorage.getItem('accessToken') || sessionStorage.getItem('userSessionName')

  return hasLocalTokens && !hasSessionIndicators
}
